<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Listing Presentations</h1>
      <div class="text-large">Get that listing.</div>
    </div>
  </div>
<Printables Category="listing-presentations" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Printables from "@/components/PrintableCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Printables
  }
};
</script>
